import { render } from "./TransactionHistoryView.vue?vue&type=template&id=65edef14&scoped=true"
import script from "./TransactionHistoryView.vue?vue&type=script&lang=js"
export * from "./TransactionHistoryView.vue?vue&type=script&lang=js"

import "./TransactionHistoryView.vue?vue&type=style&index=0&id=65edef14&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65edef14"]])

export default __exports__